import React, { useEffect, useState } from "react";

const phases = [
  {
    id: "miami",
    number: "01",
    place: "Miami / Biscayne Bay",
    title: "A city seen from the water.",
    description: "The first light finds the bay, the skyline, and the people who know how to make an entrance.",
    image: "https://static.prod-images.emergentagent.com/jobs/b6c5f7e1-3a5a-46b7-8011-48ef9d64bf7d/images/799c10b10ef03f5433ed6082d3892202f0fca278b9218efa0380c64af9723206.jpeg",
  },
  {
    id: "broward",
    number: "02",
    place: "Broward / Intracoastal",
    title: "Canals, palms, and an open invitation.",
    description: "From Las Olas to the waterline, every address becomes a setting when hospitality is considered.",
    image: "https://static.prod-images.emergentagent.com/jobs/b6c5f7e1-3a5a-46b7-8011-48ef9d64bf7d/images/96fd686806cf7f20f5847fbc3eea91e62babc27d17abbdc572c81e72fcbc1891.jpeg",
  },
  {
    id: "palm-beach",
    number: "03",
    place: "Palm Beach / Oceanfront",
    title: "The house is ready for its story.",
    description: "Manicured gardens, salt air, and the quiet confidence of a table set before the first guest arrives.",
    image: "https://static.prod-images.emergentagent.com/jobs/b6c5f7e1-3a5a-46b7-8011-48ef9d64bf7d/images/aa98eb52044a7df293a0ac695bdd51649450a9a4a70f40a8d6406764b3cc91f9.jpeg",
  },
  {
    id: "soiree",
    number: "04",
    place: "The reveal / Pop Social",
    title: "Then the night starts moving.",
    description: "A waterfront room, a curated bar, and a bartender turning the moment into something guests can taste.",
    image: "https://static.prod-images.emergentagent.com/jobs/b6c5f7e1-3a5a-46b7-8011-48ef9d64bf7d/images/fa0a1e9559dd49b6fd197ecc8b28eeea93032befb90cca3d33cf1fa0b31cf0e2.jpeg",
  },
];

export default function ImmersiveJourney() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => setActive((current) => (current + 1) % phases.length), 7600);
    return () => window.clearInterval(timer);
  }, []);

  const current = phases[active];
  return (
    <section className="journey-section" id="journey" data-testid="immersive-journey-section">
      <div className="journey-stage">
        {phases.map((phase, index) => <figure className={`journey-frame${index === active ? " is-active" : ""}`} key={phase.id} aria-hidden={index !== active}><img src={phase.image} alt={phase.place} loading={index === 0 ? "eager" : "lazy"} /></figure>)}
        <div className="journey-copy" key={current.id}>
          <div className="journey-kicker"><span>South Florida / 04 acts</span><span>{current.number}</span></div>
          <div className="journey-copy-rule" />
          <p className="journey-place">{current.place}</p>
          <h2 data-testid="journey-heading">{current.title}</h2>
          <p className="journey-description">{current.description}</p>
          <a href="#cocktails" className="button button-quiet" data-testid="journey-explore-link">Follow the pour <span>↘</span></a>
        </div>
        <div className="journey-controls" data-testid="journey-phase-controls">
          {phases.map((phase, index) => <button type="button" className={`journey-dot${index === active ? " is-active" : ""}`} key={phase.id} onClick={() => setActive(index)} data-testid={`journey-phase-${phase.id}`} aria-label={`Show ${phase.place}`} aria-pressed={index === active}><span>{phase.number}</span></button>)}
        </div>
        <div className="journey-caption">A slow flight through the places we call home <span>Miami · Broward · Palm Beach</span></div>
      </div>
    </section>
  );
}
